
(function ($, document, ns) {

    ns.ScrollTo = function (anchor, ratio, callback) {
        var $anchor = $(anchor);
        ns.ScrollToElement($anchor, ratio, callback);
    };

    ns.ScrollToWithOffSet = function (anchor, offset) {
        var $anchor = $(anchor);
        ns.ScrollToElement($anchor, 1, null, offset);
    };

    ns.ScrollToElement = function ($anchor, ratio, callback, offset) {
        offset = (typeof offset === 'undefined') ? 0 : offset;
        ratio = (typeof ratio === 'undefined') ? 1 : ratio;
        console.log('Anchor name', $anchor);
        var $persistentHeader = $('.header--sticky');
        var persistentHeaderHeight = 0;
        if ($persistentHeader.length) {
            persistentHeaderHeight = $persistentHeader.height();
        } else {
            $persistentHeader = $('.slim-layout-header--sticky');
            if ($persistentHeader.length) {
                persistentHeaderHeight = $persistentHeader.height();
            }
        }

        var scrollToPosition = $anchor.offset().top - persistentHeaderHeight + offset;

        var speed = Math.abs(scrollToPosition - $(window).scrollTop()) * 550 / (1000 * ratio);
        $.scrollTo(scrollToPosition, speed, callback);
    }

    $(document).on('click', 'a[href^="#"][href!="#"].js-anchor-scroll', function (e) {
        e.preventDefault();
        var $anchor = $($(this).attr('href'));
        ns.ScrollToElement($anchor);
    });

    $(document).ready(function () {
        if (window.location.hash && window.location.hash != '#') {
            var $anchor = $(window.location.hash);
            if ($anchor.length > 0 && $anchor.is(':visible')) {
                setTimeout(function () {
                    ns.ScrollToElement($anchor);
                }, 200);
            }
        }
    });
})(jQuery, document, Crafted.Utilities);